import axios from "./axios";

export const updateOverallRanks = (body) =>
  axios
    .patch("/admin/overall_rank", body)
    .then(({ data }) => data);

export const createBadge = (formData) =>
  axios
    .post("/admin/badges", formData, {
      headers: {
        "Content-Type": "multipart/form-data",
      },
    })
    .then(({ data }) => data);

export const updateBadge = (badgeId, formData) =>
  axios
    .patch(`/admin/badges/${badgeId}`, formData, {
      headers: {
        "Content-Type": "multipart/form-data",
      },
    })
    .then(({ data }) => data);
